import { Box } from "@mui/material";
import Headers from "../../components/Headers";

const Dashboard = () => {
  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Headers title="PRYCE SMS" />
      </Box>
    </Box>
  );
};

export default Dashboard;
